 (function() {
    'use strict';
    var MyChartBaseCtrl = function (destinationRoutePrefix, chartConsentRoute) {
        return function($scope, $q, MyChartService, PatientPortalStorageRepository, $modal, ConsentService, TransitionManager, $state, PersonRepository, gettext, toaster, BrowserService)
        {
            $scope.loading = false;
            $scope.ShowSidebar = false;
            $scope.collapseMedicalHistory = false;
            $scope.collapsePersonalDetails = true;
            $scope.myChart = {
                'User': {FullName: '', Id: '', Age: ''},
                'Config': ''
            };

            var activePatient = PatientPortalStorageRepository.getActivePatient(),
                loginUser = PatientPortalStorageRepository.getLoginUser(),
                reportRequestDto = {
                    PatientId: activePatient.id,
                    LoginUserId: loginUser.id,
                    LoginUserName: loginUser.name
                };
            var isPatientChartAccepted = false;

            var updateUsageMetricDto = {
                MetricTypeName: '170.315(e)(1) - View, Download, and Transmit to 3rd Party',
                MetricSubTypeName: 'Success',
                IncrementFactor: 1,
            };

            $scope.expandPersonalDetails = function () {
                $scope.collapseMedicalHistory = true;
                $scope.collapsePersonalDetails = false;
            };
            $scope.expandMedicalDetails = function () {
                $scope.collapseMedicalHistory = false;
                $scope.collapsePersonalDetails = true;
            };

            function loadMyChart() {
                return MyChartService.loadMyChart(activePatient.id)
                    .then(function (data) {
                        var details = data[0],
                            config = data[1];

                        $scope.myChart.User.FullName = details.FirstName + ' ' + details.LastName;
                        $scope.myChart.User.Id = details.Id;
                        $scope.myChart.User.Age = details.Age;
                        $scope.Date = details.DateOfBirth;
                        $scope.FirstName = details.FirstName;
                        $scope.LastName = details.LastName;

                        $scope.myChart.Config = config;
                    });
            }

            function getPatientChartAccepted() {
                return ConsentService.isChartConsentAccepted(activePatient.id)
                    .then(function (data) {
                        isPatientChartAccepted = data;
                        $scope.ShowSidebar = isPatientChartAccepted;
                    });
            }



            function loadController() {
                $scope.loading = true;
                $scope.removeHttpError();

                var loadMyChartPromise = loadMyChart();
                var getPatientChartAcceptedPromise = getPatientChartAccepted();

                $q.all([getPatientChartAcceptedPromise, loadMyChartPromise]).then(function() {
                    if (!isPatientChartAccepted) {
                        var currentName = $state.current.name;
                        var destinationRoute = currentName.replace(destinationRoutePrefix, '');
                        TransitionManager.transition({appRoute: chartConsentRoute, opts: {redirectRoute: destinationRoute}});
                    }
                }).catch(function (response) {
                    $scope.addHttpError(response);
                }).finally(function () {
                    $scope.loading = false;
                });
            }
            loadController();


            function displayCompleteChart() {
                //use with pdf viewer
                $scope.isModalDisplayed = true;
                auditChartResults();

                var modalInstance = $modal.open({
                    templateUrl: '/mychart/views/modals/completeChartModal.html',
                    controller: 'CompleteChartModalCtrl',
                    size: 'lg',
                    resolve: {
                        activePatient: function() {
                            return PatientPortalStorageRepository.getActivePatient();
                        }
                    }
                });

                modalInstance.result.then(function () {
                    $scope.isModalDisplayed = false;
                });
            }

            function viewCompleteChartImage() {
                $scope.isModalDisplayed = true;
                auditChartResults();

                var modalConfig = {
                    Title: gettext('Complete Chart'),
                    DownloadFileName: activePatient.firstName + activePatient.lastName + '_CompleteChart.pdf',
                    DocumentId: activePatient.id,
                    DocumentLoad: getCompleteChartImage,
                    DocumentDownload: downloadCompleteChart,
                    DisableInlinePdf: !BrowserService.supportsInlinePdf(),
                };

                var modalInstance = $modal.open({
                    templateUrl: '/app/views/viewDocumentModal.html',
                    controller: 'ViewDocumentModalCtrl',
                    windowClass: 'modal-full',
                    resolve: {
                        modalConfig: function () {
                            return modalConfig;
                        }
                    }
                });

                modalInstance.result.then(function () {
                    $scope.isModalDisplayed = false;
                });
            }

            // this function is called with a documentId, but it's not being used here,
            // since the repository call below only needs the patient id
            function getCompleteChartImage(documentId, requestSettings) {
                var patientId = activePatient.id;
                return PersonRepository.getCompleteChartImage(patientId, requestSettings);
            }

            // this function is called with a documentId, but it's not necessary here,
            // since the repository call below only needs the patient id
            function downloadCompleteChart() {
                var patientId = activePatient.id;
                var usageMetricSubTypeName = 'Success';
                auditChartResults();
                return PersonRepository.getCompleteChart(patientId)
                    .then(function (data) {
                        return {Data: data.Data, Extension: 'pdf', FileName: 'CompleteChart' + '_' + activePatient.fullName};
                    })
                    .catch(function () {
                        usageMetricSubTypeName = 'Failure';
                        toaster.pop('error', '', gettext('An error occurred while downloading'));
                    })
                    .finally(function () {
                        updateUsageMetric(usageMetricSubTypeName);
                    });
            }

            var showChartSidebarListener = $scope.$on('ShowChartSidebar:updated', function (event, data) {
                $scope.ShowSidebar = data;
            });

            $scope.$on('$destroy', function() {
                showChartSidebarListener();  // un-subscribed listener event
            });

            function auditChartResults() {
                MyChartService.auditChartLogging(reportRequestDto);
            }

            function updateUsageMetric(metricSubTypeName) {
                updateUsageMetricDto.MetricSubTypeName = metricSubTypeName;
                MyChartService.usageMetricLogging(updateUsageMetricDto);
            }

            $scope.displayCompleteChart = displayCompleteChart;
            $scope.viewCompleteChartImage = viewCompleteChartImage;
        };
    };
    var MyChartCtrl = new MyChartBaseCtrl('myChart.', 'chartConsent');
    var MyChartMobileCtrl = function ($scope, $q, MyChartService, PatientPortalStorageRepository, $modal, ConsentService, TransitionManager, $state, PersonRepository, gettext, toaster) {
        new MyChartBaseCtrl('myChartMobile.', 'chartMobileConsent').call(this, $scope, $q, MyChartService, PatientPortalStorageRepository, $modal, ConsentService, TransitionManager, $state, PersonRepository, gettext, toaster);
        $scope.openPersonalDetails = $state.params.openPD === 'true';
    };
    angular.module('mychart').controller('MyChartCtrl',
        ['$scope', '$q', 'MyChartService', 'PatientPortalStorageRepository', '$uibModal', 'ConsentService', 'TransitionManager', '$state', 'PersonRepository', 'aprgettext', 'toaster',
        'BrowserService',
            MyChartCtrl]);
    angular.module('mychart').controller('MyChartMobileCtrl',
        ['$scope', '$q', 'MyChartService', 'PatientPortalStorageRepository', '$uibModal', 'ConsentService', 'TransitionManager', '$state', 'PersonRepository', 'aprgettext', 'toaster',
        'BrowserService',
            MyChartMobileCtrl]);
 })();
